<template>
  <TransitionRoot appear :show="modal" as="template">
    <Dialog as="div" @close="modal = false" class="relative z-50">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-3xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all"
            >
              <div class="grid grid-cols-2">
                <div class="col-span-2 sm:col-span-1">
                  <div class="py-6 px-6">
                    <h3 class="font-semibold text-2xl mt-6">
                      {{ dataLocale.data.title }}
                    </h3>

                    <div class="mt-8 text-lg">
                      <q class="">
                        {{ dataLocale.data.p1 }}
                      </q>
                      <p class="mt-4">
                        {{ dataLocale.data.p2 }}
                      </p>
                      <div class="flex items-center flex-col mt-12 gap-2">
                        <a
                          target="_blank"
                          href="https://app.qrgateway.com/sign-up"
                          class="flex items-center gap-2 h-[50px] px-4 rounded-xl bg-success text-white drop-shadow-md hover:drop-shadow-xl"
                        >
                          {{ $t("sign_trial") }}
                        </a>
                        <span> No credit card required </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-span-1 hidden sm:block relative">
                  <img
                    src="/popmedia.jpg"
                    class="h-full object-cover min-w-full"
                    alt="media-popup"
                  />
                  <button
                    @click="modal = false"
                    class="absolute top-4 right-4 w-12 h-12 bg-neutral-50 opacity-70 hover:opacity-100 rounded-full flex-center"
                  >
                    <XIcon />
                  </button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useLimit } from "~~/stores/limit";
import { XIcon } from "vue-tabler-icons";
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
} from "@headlessui/vue";
const { modal } = storeToRefs(useLimit());
import DataLocale from "~~/config/interface/DataLocale";

const dataLocale = new DataLocale([
  {
    locale: "en",
    title: " You have reached your limit create qr codes today.",
    p1: "A single QR code for all your social channels and business requirements",
    p2: "  Please register or log in to your account to continue.",
  },
  {
    locale: "es",
    title: "Has alcanzado tu límite de creación de códigos QR hoy.",
    p1: "Un solo código QR para todos tus canales sociales y necesidades comerciales.",
    p2: "Por favor, regístrate o inicia sesión en tu cuenta para continuar.",
  },
  {
    locale: "pt",
    title: "Você atingiu seu limite de criação de códigos QR hoje.",
    p1: "Um único código QR para todos os seus canais sociais e necessidades comerciais.",
    p2: "Por favor, registre-se ou faça login em sua conta para continuar.",
  },
  {
    locale: "de",
    title:
      "Sie haben Ihr Limit für die Erstellung von QR-Codes heute erreicht.",
    p1: "Ein einzelner QR-Code für alle Ihre sozialen Kanäle und geschäftlichen Anforderungen.",
    p2: "Bitte registrieren Sie sich oder melden Sie sich in Ihrem Konto an, um fortzufahren.",
  },
  {
    locale: "fr",
    title:
      "Vous avez atteint votre limite de création de codes QR aujourd'hui.",
    p1: "Un seul code QR pour tous vos réseaux sociaux et besoins professionnels.",
    p2: "Veuillez vous inscrire ou vous connecter à votre compte pour continuer.",
  },
  {
    locale: "it",
    title: "Hai raggiunto il limite di creazione di codici QR oggi.",
    p1: "Un unico codice QR per tutti i tuoi canali sociali e le tue esigenze aziendali.",
    p2: "Per favore, registrati o accedi al tuo account per continuare.",
  },
  {
    locale: "nl",
    title: "U heeft uw limiet voor het maken van QR-codes vandaag bereikt.",
    p1: "Eén QR-code voor al uw sociale kanalen en zakelijke behoeften.",
    p2: "Registreer of log in op uw account om door te gaan.",
  },
  {
    locale: "vi",
    title: "Bạn đã đạt đến giới hạn tạo mã QR hôm nay.",
    p1: "Một mã QR duy nhất cho tất cả các kênh mạng xã hội và nhu cầu kinh doanh của bạn.",
    p2: "Vui lòng đăng ký hoặc đăng nhập vào tài khoản của bạn để tiếp tục.",
  },
  {
    locale: "ja",
    title: "今日、QRコードの作成制限に達しました。",
    p1: "あなたのすべてのソーシャルチャネルとビジネスニーズのための単一のQRコード。",
    p2: "続行するには、登録またはログインしてください。",
  },
  {
    locale: "zh",
    title: "您今天已达到创建QR码的限制。",
    p1: "一个QR码覆盖所有社交渠道和商业需求。",
    p2: "请注册或登录您的帐户以继续。",
  },
]);
</script>
